<div class="spacing--margin-top flex--row flex--nowrap">
  <ng-container *ngIf="feedAdviceType === 'SowsBreedToFarrow'">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.body-condition.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        class="formfield-outline"
        (selectionChange)="changeProperties()"
        [(ngModel)]="bodyCondition"
        data-test="feed-advice-properties__body-condition"
      >
        <mat-option *ngFor="let bodyCondition of bodyConditionTypes" [value]="bodyCondition">
          {{ 'feed-advice-properties.body-condition.' + bodyCondition | translate }}
        </mat-option>
      </mat-select>
    </div>
  </ng-container>

  <div class="flex--column">
    <span class="text--small text--bold label">
      {{ 'feed-advice-properties.genetic-line' | translate }}
    </span>
  </div>
  <div class="flex--column spacing--padding-right">
    <mat-select
      [hideSingleSelectionIndicator]="true"
      class="formfield-outline"
      (selectionChange)="selectGeneticLine($event)"
      placeholder=" {{ 'feed-advice-properties.genetic-line-default' | translate }}"
      [(ngModel)]="geneticLine"
      data-test="feed-advice-properties__genetic-line"
    >
      <mat-option [value]="null">
        {{ 'feed-advice-properties.genetic-line-default' | translate }}
      </mat-option>
      <mat-option *ngFor="let geneticLine of geneticLineTypes" [value]="geneticLine">
        {{ geneticLine | translate }}
      </mat-option>
    </mat-select>
  </div>
  <ng-container *ngIf="feedAdviceType === 'SowsFarrowToWean'">
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.piglets-per-farrowing' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        class="formfield-outline"
        (selectionChange)="changeProperties()"
        [(ngModel)]="pigletsPerFarrowingCategory"
        data-test="feed-advice-properties__piglets-per-farrowing"
      >
        <mat-option
          *ngFor="let pigletsPerFarrowingCategory of pigletsPerFarrowingCategories"
          [value]="pigletsPerFarrowingCategory"
        >
          {{ pigletsPerFarrowingCategory }}
        </mat-option>
      </mat-select>
    </div>
    <div class="flex--column">
      <span class="text--small text--bold label">
        {{ 'feed-advice-properties.transitionDay.label' | translate }}
      </span>
    </div>
    <div class="flex--column spacing--padding-right" [formGroup]="formGroup">
      <input
        (change)="changeProperties()"
        matInput
        class="formfield-outline"
        [min]="1"
        [max]="115"
        [value]="transitionDay"
        data-test="feed-advice-properties__transition-day"
        formControlName="transitionDay"
        type="number"
        [class.error-border]="
          transitionDayFormControl.errors?.max || transitionDayFormControl.errors?.min
        "
      />
    </div>
    <div
      class="error label"
      *ngIf="transitionDayFormControl.errors?.max || transitionDayFormControl.errors?.min"
    >
      {{ 'feed-advice-properties.transitionDay.error' | translate }}
    </div>
  </ng-container>
</div>
